/* Always Friday PDP accordions
 * - Single-open behaviour (opening one closes the others in the same group)
 * - Animated open/close via WAAPI, since native <details> snaps instantly
 * - cubic-bezier(0.4, 0, 0.2, 1) easing, 320ms
 */
(function () {
  'use strict';

  const DURATION = 340;
  const EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

  class AfAccordion {
    constructor(el, group) {
      this.el = el;
      this.group = group;
      this.summary = el.querySelector('.af-acc__summary');
      this.content = el.querySelector('.af-acc__panel');
      if (!this.summary || !this.content) return;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.openItem();
        if (this.group) {
          this.group.items.forEach((other) => {
            if (other !== this && (other.el.open || other.isExpanding)) other.shrink();
          });
        }
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;
      this.isExpanding = false;
      const start = `${this.el.offsetHeight}px`;
      const end = `${this.summary.offsetHeight}px`;
      if (this.animation) this.animation.cancel();
      this.animation = this.el.animate(
        { height: [start, end] },
        { duration: DURATION, easing: EASING }
      );
      this.animation.onfinish = () => this.onFinish(false);
      this.animation.oncancel = () => { this.isClosing = false; };
    }

    openItem() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      this.isClosing = false;
      const start = `${this.el.offsetHeight}px`;
      const end = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
      if (this.animation) this.animation.cancel();
      this.animation = this.el.animate(
        { height: [start, end] },
        { duration: DURATION, easing: EASING }
      );
      this.animation.onfinish = () => this.onFinish(true);
      this.animation.oncancel = () => { this.isExpanding = false; };
    }

    onFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = '';
      this.el.style.overflow = '';
    }
  }

  function init(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const groups = scope.querySelectorAll('[data-section-type="af-accordions"]');
    groups.forEach((group) => {
      if (group.dataset.afBound === '1') return;
      group.dataset.afBound = '1';
      const itemEls = group.querySelectorAll('[data-af-item]');
      const ctx = { items: [] };
      itemEls.forEach((el) => ctx.items.push(new AfAccordion(el, ctx)));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target) init(e.target);
  });
})();
